module.exports = __webpack_public_path__ + "static/media/dish15.d5f12b09.jpg";